'use strict';

var React = require('react');
var MenuLink = require('./MenuLink');

module.exports = React.createClass({

	displayName: 'InfoPageMenu',

	propTypes: {
		model: React.PropTypes.object.isRequired
	},

	render: function () {
		var infoPageLinks = this.props.model.infoPageLinks;

		return (
			<nav className="svtse_menu__info-page-menu" role="navigation" aria-label="Tjänster på SVT.se">
				<ul className="svtse_menu__info-page-menu__items">
					{infoPageLinks.map(function (link, index) {
						return (
							<li key={index} className="svtse_menu__info-page-menu__item">
								<MenuLink className="svtse_menu__info-page-menu__item-link" model={link}>{link.title}</MenuLink>
							</li>
						);
					})}
				</ul>
			</nav>
		);
	}
});



/** WEBPACK FOOTER **
 ** ./app/components/menu/InfoPageMenu.js
 **/